import {
    closestCorners,
    pointerWithin,
    rectIntersection,
    type CollisionDetection,
} from '@dnd-kit/core';

/** Порожні колонки: pointerWithin; інакше картки для reorder; fallback — closestCorners */
export const kanbanCollisionDetection: CollisionDetection = (args) => {
    const pointerHits = pointerWithin(args);
    if (pointerHits.length > 0) {
        const overCard = pointerHits.find((c) => !String(c.id).startsWith('col-'));
        if (overCard) return [overCard];
        return pointerHits;
    }

    const rectHits = rectIntersection(args);
    if (rectHits.length > 0) {
        const overCard = rectHits.find((c) => !String(c.id).startsWith('col-'));
        if (overCard) return [overCard];
        return rectHits;
    }

    return closestCorners(args);
};
